//when edit button is pressed in the parent, this component should a render within the card component, within the notes section.


//as props accept the jobsite id, and the notes object.
import React, { useState, useEffect } from 'react';
import { TbPlus } from "react-icons/tb";
import { FaCheckDouble } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { submitNote } from '../actions/submitNote';
import { updateJobsiteNotes } from '../features/jobsites/jobsitesSlice';

const NotesInCards = ({ jobSite , setEditNotesClicked}) => {
    const MAX_MESSAGE = 250;
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    //grab the user token from redux store
    const dispatch = useDispatch();
    const {token} = useSelector(state => state.auth.user);
    //this is a json object of notes. It may be empty, or it may have notes in it. It will be sent to the backend to stire in the database. 
    const [notes, setNotes] = useState({});
    
    //sets the edit notes button to false, which will close the edit notes component.
    const handleCancel = () => {
        setNotes({}); //clears the notes object
        setEditNotesClicked(false);
      };

    const handleSubjectChange = (e) => {
        setSubject(e.target.value);
    };

    const handleMessageChange = (e) => {
        if (e.target.value.length <= MAX_MESSAGE) setMessage(e.target.value);
    };

    //take the existing notes object and submit it to the backend. To be stored in the database. 
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        //if subject and message are not empty, add them to the notes object
        if(subject && message  ){
           handleAddNote();
           setIsSubmitting(true);        
        }else{
           setIsSubmitting(true); 
        }
    };

    useEffect(() => {
        if (isSubmitting && Object.keys(notes).length > 0) { // only call submitNote if isSubmitting is true and notes is not empty
            submitNote(token, jobSite.id, notes)
                .then((updatedNotes) => {
                    toast.success('Notes submitted successfully');
                    dispatch(updateJobsiteNotes({ jobsiteId: jobSite.id, siteNotes: updatedNotes }));
                    setIsSubmitting(false); // Set isSubmitting to false after submitNote has been called
                })
                .catch((error) => {
                    // Handle error here
                    console.error(error);
                    setIsSubmitting(false); // Set isSubmitting to false if an error occurs
                });
        }
    }, [notes, jobSite.id, token, submitNote, isSubmitting]);
   

    const handleAddNote = () => {
        if (subject && message) {
            const newNote = {
                ...notes,
                [subject]: message
            };

            setNotes(newNote);

            // Clear the subject and message fields for the next note
            setSubject('');
            setMessage('');
        } else {
            toast.error('Subject and message cannot be empty');
        }
    };

    return (
        <div className="relative bg-charcoal rounded-xl shadow-lg p-5 border border-gray-700 max-w-md mx-auto animate-fade-in">
            {/* Close Button */}
            <button
                type="button"
                onClick={handleCancel}
                className="absolute top-3 right-3 text-red-500 hover:text-red-400 transition"
            >
                <MdOutlineCancel className='text-2xl' />
            </button>
            <form onSubmit={handleSubmit}>
                <h2 className="text-md font-medium text-white mb-4 tracking-wide flex items-center gap-2">
                  <TbPlus className="inline text-lilac" /> Post a Note
                </h2>
                <div className="mb-4">
                    <label htmlFor="subject" className="block text-gray-300 font-medium mb-1 text-left text-sm tracking-wide">
                        Subject
                    </label>
                    <input
                        type="text"
                        id="subject"
                        className="w-full py-2 px-3 border border-gray-600 rounded-lg bg-gray-900 text-white focus:outline-none focus:border-lilac text-base transition"
                        value={subject}
                        onChange={handleSubjectChange}
                        placeholder="OSHA Safety Reminder"
                        autoFocus
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="message" className="block text-gray-300 font-medium mb-1 text-left text-sm tracking-wide">
                        Message
                    </label>
                    <textarea
                        id="message"
                        className="w-full py-2 px-3 rounded-lg border border-gray-600 bg-gray-900 text-white focus:outline-none focus:border-lilac text-base min-h-[80px] resize-vertical transition"
                        value={message}
                        onChange={handleMessageChange}
                        placeholder="Type your note here..."
                        maxLength={MAX_MESSAGE}
                    ></textarea>
                    <div className="flex justify-between items-start mt-1">
                        <p className="text-left text-xs text-lilac font-mono">
                            {Object.keys(notes).length > 0
                                ? Object.keys(notes).join(', ')
                                : ''}
                        </p>
                        <p className={`text-xs font-mono shrink-0 ml-2 ${MAX_MESSAGE - message.length <= 20 ? 'text-red-400' : 'text-gray-500'}`}>
                            {MAX_MESSAGE - message.length}
                        </p>
                    </div>
                </div>
                
                <div className="flex justify-end gap-3 mt-6">
                    
                    <button
                        type="button"
                        onClick={handleAddNote}
                        className="flex items-center gap-1 text-xs font-normal text-gray-100"
                    >
                        <TbPlus className="text-base" /> Additional note
                    </button>
                    <button
                        type="submit"
                        className="flex items-center gap-1 text-xs font-normal text-gray-100"
                    >
                        <FaCheckDouble className='text-base' /> Submit all notes
                    </button>
                </div>
            </form>
        </div>
    );
};

export default NotesInCards;

